import type { FaireProductEntity } from "../../entity_types/product";

export const p_vvufs2x8er: FaireProductEntity = {
  token: "p_vvufs2x8er",
  type: "product",
  name: "1 lb Natural Garden Quartz Lodalite Freeform",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/47813ea7b2c35c58007bb4cb6e9860a54b815861f9eb1c940a5e07bad3de6c97.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/74e80ed24036f845da808157e01f2cf31be4854a3a0e1e1c6199e55ac6d3ad87.png",
    "https://cdn.faire.com/fastly/649a9f795aba5d2ff51544c2604077ac32251ee0962b2d14925140532c7c357a.png",
    "https://cdn.faire.com/fastly/9e5938a9f1afe88c1134f2c2896b79553a03b5dc3a0c6bde0bef0694a2388613.png",
    "https://cdn.faire.com/fastly/7f1b7319954f5694e59e5e2f39b6de91dd65fb9fb2956e1f5d74061929cb153d.png",
  ],
  priceDollars: 80.37,
  description:
    "Wholesale lot 1 lb Natural Garden Quartz Lodalite crystal Freeform. These Freeform can range can range .5” to 2” and roughly 5 to 8 pcs. Condition is New. Free local pickup in Brooklyn, New York. Stones, stone wholesale, crystals, crystal bulk, crystal wholesale, spiritual, spiritual items, meditation, metaphysical wholesale. \n",
  tags: [],
  msrpDollars: 160.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:37.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
